import type { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from '#client/lib/cn';

interface CheckboxProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type' | 'className' | 'children'
> {
  label: ReactNode;
  className?: string | undefined;
  /** The "some but not all" state of a select-all box. Not an attribute, so set by ref. */
  indeterminate?: boolean | undefined;
}

export function Checkbox({ label, className, indeterminate = false, ...input }: CheckboxProps) {
  return (
    <label className={cn('c-checkbox', input.disabled && 'is-disabled', className)}>
      <input
        {...input}
        ref={(element) => {
          if (element) element.indeterminate = indeterminate;
        }}
        type="checkbox"
        className="c-checkbox__control"
      />
      <span className="c-checkbox__label">{label}</span>
    </label>
  );
}
